import React from "react";
import { allergensList } from "../../../utilities/allergensList";

const Allergen = ({ allergen }) => {
  const name = allergensList.find((a) => a.code === allergen.allergenName)?.name || allergen.allergenName;

  const cell = { padding: "7px 10px", color: "var(--ink-soft)" };
  const centerCell = { ...cell, textAlign: "center" };

  const Badge = ({ yes }) =>
    yes ? (
      <span style={{ display: "inline-block", padding: "2px 8px", borderRadius: "20px", fontSize: "11px", fontWeight: 600, background: "var(--brand-light)", color: "var(--brand)" }}>
        Yes
      </span>
    ) : null;

  return (
    <tr style={{ borderBottom: "1px solid var(--border)" }}>
      <td style={{ ...cell, fontWeight: 500, color: "var(--ink)" }}>{name}</td>
      <td style={centerCell}><Badge yes={allergen.mayContain} /></td>
      <td style={centerCell}><Badge yes={allergen.included} /></td>
      <td style={centerCell}><Badge yes={allergen.alternativeAvailable} /></td>
      <td style={{ ...cell, fontSize: "12px", color: "var(--ink-muted)" }}>{allergen.alternativeDetails || "—"}</td>
    </tr>
  );
};

export default Allergen;
